import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import CreateReferenceModal from '../../../../components/CreateReferenceModal/CreateReferenceModal'
import { getArticleById, updateReference } from '../../../../entity/volumes/Volumes'
import { MdOutlineModeEdit } from 'react-icons/md'

const EditReference = ({ articleId, reference }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const EditReferenceHandler = async data => {
    if (reference?.id && data) {
      const res = await dispatch(
        updateReference({ referenceId: reference?.id, referenceData: data })
      )

      if (updateReference.fulfilled.match(res)) {
        const articleResp = await dispatch(getArticleById(articleId))
        if (articleResp.fulfilled.match(articleResp)) {
          console.log('issueResp:', articleResp)
        } else {
          console.error('Error getting issue:', articleResp.payload || articleResp.error.message)
        }
      } else if (updateReference.rejected.match(res)) {
        console.error('Error creating issue:', res.payload || res.error.message)
      }
    }
    modalHandler()
  }

  return (
    <>
      <MdOutlineModeEdit
        className='hover:cursor-pointer hover:scale-105 transition-all text-[#002336]'
        onClick={modalHandler}
      />

      {isOpen && (
        <CreateReferenceModal
          isOpen={isOpen}
          onClose={modalHandler}
          onSubmit={EditReferenceHandler}
          data={reference}
        />
      )}
    </>
  )
}

export default EditReference
